<div class="cea-page-container container" id="wrap" [ngClass]="{'admin-page': router.url.includes('\admin')}">
    <div id="primary-container" class="container-fluid-override">
        <router-outlet></router-outlet>
    </div>
</div>